import { render, staticRenderFns } from "./PriceManipulationsNew.vue?vue&type=template&id=647bf290&scoped=true"
import script from "./PriceManipulationsNew.vue?vue&type=script&lang=ts"
export * from "./PriceManipulationsNew.vue?vue&type=script&lang=ts"
import style0 from "./PriceManipulationsNew.vue?vue&type=style&index=0&id=647bf290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647bf290",
  null
  
)

export default component.exports